<template>
  <div style="position: relative; margin-right: 0.5em">
    <div
      :class="errorClass"
      class="avatar-input"
      :style="[
        visitor.personal.avatar
          ? {'background-image' : 'url(' + visitor.personal.avatar + ')', 'cursor' : 'pointer'}
          : isLoadingAvatar
            ? {'background-color' : '#eef1f6', 'cursor' : 'default'}
            : {'background-image' : 'url(' + defaultImage + ')', 'background-size' : '31px', 'cursor' : 'pointer'}
      ]"
      @click.self="visitor.personal.avatar ? openModalOrCoolLightBox() : ''"
      @drop="onDrop"
      @dragenter.prevent
      @dragover.prevent
    >
      <div v-if="isLoadingAvatar" class="avatar-input-spinner">
        <div class="avatar-input-spinner__ring"></div>
      </div>
      <CoolLightBox
        v-if="canView"
        :items="[{ src: visitor.personal.avatar }]"
        :index="showCoolLightBox"
        :useZoomBar="true"
        style="cursor: auto"
        @close="onCoolLightBoxClose"
      />
      <input
        v-if="showFileInput"
        accept=".jpeg, .jpg, .png, .bmp"
        title="Перетащите сюда фотографию посетителя или нажмите для выбора файла"
        ref="inputFile"
        style="opacity: 0; position: absolute; top: 0; left: 0; bottom: 0; right: 0; width: 100%; height:100%;"
        type="file"
        @change="onInputChange"
      >
    </div>
    <div v-if="showModal" class="modal-overlay" tabindex="0">
      <div class="photo-editor-modal">
        <div class="photo-editor-modal__header">
          <a class="modal__close" @click="closeModal"></a>
          <h4 class="modal__title">Отредактируйте фото</h4>
        </div>
        <div class="photo-editor-modal__body-scroll">
          <div class="photo-editor-modal__body">
            <div class="photo-editor__container">
              <div class="photo-editor__hints-container">
                <div class="photo-editor__moving-hint">
                  <img alt="" :src="baseUrl + 'move-icon.svg'">
                  <span>Перетащите фото,<br>чтобы изменить<br>положение</span>
                </div>
                <div class="photo-editor__scroll-hint">
                  <img alt="" :src="baseUrl + 'scroll-icon.svg'">
                  <span>Масштабировать изображение<br>можно вращением<br>колеса мышки</span>
                </div>
              </div>
              <div class="photo-editor__cropper-container" style="position: relative;">
                <div class="photo-editor__cropper">
                  <div>
                    <cropper
                      :src="imageUrl"
                      :stencil-props="{
                           handlers: {},
                           lines: {},
                           movable: false,
                           scalable: false,
                      }"
                      :stencil-size="{
                           width: 306,
                           height: 393
                      }"
                      :canvas="{
                        width: 413,
                        height: 531
                      }"
                      image-restriction="stencil"
                      ref="cropper"
                      style="width: 306px; height: 393px"
                    />
                    <img
                      :src="baseUrl + 'photo-mask-desktop.svg'"
                      alt=""
                      style="position:absolute; top: 0; pointer-events: none;"
                    >
                  </div>
                </div>
                <div class="photo-editor__actions">
                  <button class="btn" @click="zoomOut()">
                    <span class="glyphicon glyphicon-zoom-out"></span>
                  </button>
                  <button class="btn" @click="zoomIn()">
                    <span class="glyphicon glyphicon-zoom-in"></span>
                  </button>
                  <button class="btn" @click="rotate(90)">
                    <span class="glyphicon glyphicon-repeat"></span>
                  </button>
                </div><!---->
              </div>
              <div class="photo-editor__position-hints-container">
                <div>
                    <span>Загрузка фотографии посетителя в сервис на этапе оформления заявки позволяет ускорить процедуру выдачи пропуска посетителю.<br>
                      Если загруженная фотография соответствует <a href="https://konversta.com/ru/services/pass/photo" target="_blank">требованиям</a>, то при получении пропуска посетителю не придется повторно фотографироваться.
                    </span>
                </div>
              </div>
            </div>
            <div class="photo-editor-modal__footer">
              <div class="photo-editor-modal__buttons">
                <div class="button-container small-paddings modal-button" style="position: relative">
                  <button class="btn btn-default" tabindex="0" @click="openInput">
                    <span>Выбрать другое фото </span>
                  </button>
                </div>
                <div class="button-container small-paddings">
                  <button class="btn btn-primary" tabindex="0" @click="cropImage">
                    <span>Сохранить и продолжить </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import permissionsMixin from '@/common/mixins/PermissionsMixin'
import CoolLightBox from 'vue-cool-lightbox'
import '../../../../assets/styles/avatar-input.css'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'

export default {
  name: 'AvatarInput',

  components: {
    CoolLightBox,
    Cropper
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    permissionsMixin
  ],

  props: {
    inputName: {
      default: 'avatar'
    },

    visitor: {
      type: Object
    },

    allowAttach: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showCoolLightBox: null,
      isLoadingAvatar: false,
      baseUrl: `${process.env.BASE_URL}img/components/avatarInput/`,
      showModal: false,
      imageFile: undefined,
      croppedImage: undefined,
      zoomFactor: 1.2,
      fileTypes: [
        'image/bmp',
        'image/jpeg',
        'image/png'
      ]
    }
  },

  computed: {
    canView() {
      return this.hasPermission(PermissionsEnum.canViewVisitorAvatar)
    },

    canEdit() {
      return this.allowAttach && this.canAttachOrHasPermission
    },

    canAttachOrHasPermission() {
      return Number(this.configuration.user_attach_avatar) === 1 ||
        this.hasPermission(PermissionsEnum.canEditVisitorAvatar)
    },

    defaultImage() {
      return this.baseUrl + 'add-photo-icon.svg'
    },

    errorClass() {
      if (this.hasInputErrors && !this.visitor.personal.avatar && !this.isLoadingAvatar) {
        return 'has-error'
      }

      return ''
    },

    imageUrl() {
      if (typeof this.imageFile === 'string') {
        return this.imageFile
      }

      return this.imageFile ? URL.createObjectURL(this.imageFile) : null
    },

    isNotView() {
      return this.isNew || this.isDuplicate || this.isDraft
    },

    showFileInput() {
      if (this.showModal) {
        return true
      }

      if (this.visitor.personal.avatar || this.isLoadingAvatar) {
        return false
      }

      return this.canEdit
    }
  },

  mounted() {
    this.fetchAvatarIfNeeded()
  },

  methods: {
    async fetchAvatarIfNeeded() {
      if (
        !this.canView ||
        !this.visitor.personal.has_avatar ||
        this.visitor.personal.avatar ||
        !this.visitor.personal.id ||
        !this.form?.application?.id
      ) {
        return
      }

      this.isLoadingAvatar = true
      try {
        const response = await ApiClient.visitorAvatar({
          application_id: this.form.application.id,
          personal_id: this.visitor.personal.id
        })
        const avatar = response?.data?.data?.avatar
        if (avatar) {
          this.$set(this.visitor.personal, 'avatar', avatar)
        }
      } finally {
        this.isLoadingAvatar = false
      }
    },

    clearInput() {
      if (this.$refs.inputFile) {
        this.$refs.inputFile.value = ''
      }
    },

    closeModal() {
      this.releaseScroll()
      this.clearInput()
      this.showModal = false
    },

    async cropImage() {
      const { canvas } = this.$refs.cropper.getResult()
      this.visitor.personal.avatar = canvas.toDataURL('image/jpeg')
      this.closeModal()

      if (!this.isNew && !this.isDuplicate) {
        await ApiClient.uploadAvatar({
          userId: this.visitor.personal.id,
          file: this.visitor.personal.avatar
        })
      }
    },

    loadImageFile(file) {
      if (!this.validFileType(file)) {
        alert('Неверное расширение файла. Принимаемые расширения файлов: bmp jpeg png')
        return false
      }
      if (!this.validateFileSize(file)) {
        alert('Размер файла не должен превышать 20 мегабайта')
        return false
      }
      this.imageFile = file

      return true
    },

    lockScroll() {
      document.body.classList.add('modal-open')
      document.documentElement.classList.add('modal-open') // html tag
    },

    releaseScroll() {
      document.body.classList.remove('modal-open')
      document.documentElement.classList.remove('modal-open') // html tag
    },

    onDrop(event) {
      event.preventDefault()
      event.stopPropagation()
      if (this.loadImageFile(event.dataTransfer.files[0]) && this.canEdit) {
        this.openModal()
      }
    },

    onInputChange({ target }) {
      if (this.loadImageFile(target.files[0]) && this.canEdit) {
        this.openModal()
      }
    },

    openInput() {
      this.clearInput()
      this.$refs.inputFile.click()
    },

    openModal() {
      this.showModal = true
      this.lockScroll()
    },

    onCoolLightBoxClose() {
      this.releaseScroll()
      this.showCoolLightBox = null
    },

    openModalOrCoolLightBox() {
      if (this.visitor.personal.avatar) {
        if (this.canEdit) {
          this.imageFile = this.visitor.personal.avatar
          this.openModal()
        } else if (this.canView) {
          this.showCoolLightBox = 0
          this.lockScroll()
        }
      }
    },

    rotate(angle) {
      this.$refs.cropper.rotate(angle)
    },

    validFileType(file) {
      return this.fileTypes.includes(file.type)
    },

    validateFileSize(file) {
      return file.size <= 1024 * 1024 * 20 // 20Mb
    },

    zoomIn() {
      this.$refs.cropper.zoom(this.zoomFactor)
    },

    zoomOut() {
      this.$refs.cropper.zoom(1 / this.zoomFactor)
    }
  }
}
</script>
